<template>
    <field-input
        class="d-flex flex-column is-phone" :class="{'is-dirty': this.number != ''}"
        v-model="number"
        :id="getFieldId"
        :label="getLabel"
        :readonly="readonly"
        :name="name"
        :required="required"
        :sublabel="sublabel"
        @input="updateValue($event)"
        @focus="updateValue($event, 'focus')"
        @blur="updateValue($event, 'blur')"
        @keyup="updateValue($event, 'keyup')">
    </field-input>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        data() {
            return {
                selector: null,
                input: null,
                inputValue: '',
                code: '1',
                number: '',
                countries: [],
            }
        },

        mounted() {
            this.createInputPhone();
            $('#' + this.getFieldId).mask('(000) 000-0000 Ext (000)');
        },

        created(){
            App.bus.$on('phone-input-refresh', () => {
                // this.setPhoneNumber();
            })
        },

        methods: {

            createInputPhone() {
                this.countries = window.intlTelInputGlobals.getCountryData();
                this.selector = document.querySelector(`#${this.getFieldId}`);
                this.input = window.intlTelInput(this.selector, {
                    formatOnDisplay: true,
                    separateDialCode: true,
                });
                this.initPhoneNumber();
            },

            initPhoneNumber() {
                this.parsePhoneNumber();

                // Add listener
                this.selector.addEventListener("countrychange", () => {
                    this.code = this.input.getSelectedCountryData().dialCode;
                    this.updateValue();
                });
            },

            /**
             * Update the field input value.
             */
            updateValue() {
                this.$emit('input', this.code + ' ' + this.number)
            },

            /**
             * Initalize the input with the value passed on the prop.
             */
            parsePhoneNumber() {
                if (this.value == null || this.value == '') return;

                var code = this.value.substr(0, this.value.indexOf(' '));
                var country = this.countries.find(country => {
                    if (code == 1 && country.name != 'United States') return false
                    return country.dialCode == code;
                });

                var iso2 = country ? country.iso2 : 'us';
                this.input.setCountry(iso2);

                this.code = country ? country.dialCode : '1';
                this.number = country ? this.value.substring(this.value.indexOf(' ') + 1) : this.value;
            },
        },

        watch: {
            value() {
                this.parsePhoneNumber();
            },
        },

        computed: {
                // getLabel(){
                //     return this.floating ? "" : this.label;
                // },
        }

    }
</script>
